import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradleProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradleProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          compile '{component.coordinate1}:{component.coordinate2}:{version.version}'
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle;
